import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/collapse';

import '../stylesheets/application';

require.context('../images', true);
